export const styles = {
  loadingBox: {
    minHeight: 292,
    minWidth: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};